<template>
  <div>
    <!-- <a-table :columns="columns" :data-source="data" :showHeader="false">
    <a slot="name" slot-scope="text">{{ text }}</a>
    <span slot="customTitle"><a-icon type="smile-o" /> Name</span>
    <span slot="tags" slot-scope="tags">
      <a-tag
        v-for="tag in tags"
        :key="tag"
        :color="tag === 'loser' ? 'volcano' : tag.length > 5 ? 'geekblue' : 'green'"
      >
        {{ tag.toUpperCase() }}
      </a-tag>
    </span>
    <span slot="action" slot-scope="text, record">
      <a>Invite 一 {{ record.name }}</a>
      <a-divider type="vertical" />
      <a>Delete</a>
      <a-divider type="vertical" />
      <a class="ant-dropdown-link"> More actions <a-icon type="down" /> </a>
    </span>
  </a-table> -->
    <a-descriptions
      title=""
      bordered
      :column="{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }"
    >
      <a-descriptions-item label="声音提醒">
        <a-switch default-checked @change="onChange" />
        <p>当前有新的客服通知会响铃提醒</p>
      </a-descriptions-item>
      <a-descriptions-item label="系统版本">
        <a-badge
          count="v1.1.6"
          :number-style="{ backgroundColor: '#52c41a' }"
        />
      </a-descriptions-item>
      <a-descriptions-item label="系统有效期"> 永久有效 </a-descriptions-item>
    </a-descriptions>
    <div class=""></div>
  </div>
</template>
<script>
const columns = [
  {
    dataIndex: "name",
    key: "name",
    slots: { title: "customTitle" },
    scopedSlots: { customRender: "name" },
  },
  {
    title: "Age",
    dataIndex: "age",
    key: "age",
  },
];

const data = [
  {
    key: "1",
    name: "系统提醒",
    age: 32,
    address: "New York No. 1 Lake Park",
    tags: ["nice", "developer"],
  },
  {
    key: "2",
    name: "系统版本",
    age: 42,
    address: "London No. 1 Lake Park",
    tags: ["loser"],
  },
  {
    key: "3",
    name: "系统有效期",
    age: 32,
    address: "Sidney No. 1 Lake Park",
    tags: ["cool", "teacher"],
  },
];

export default {
  data() {
    return {
      data,
      columns,
    };
  },
  methods: {
    onChange() {},
  },
};
</script>
<style scoped>
</style>




// WEBPACK FOOTER //
// src/views/home/systemInformationFormTwo.vue